import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgFormatNumberPipe } from './formatting/format-number.pipes';
import { NgTruncatePipe } from './formatting/truncate.pipes';
import { NgExactRemainingTimePipe } from './measurements/remaining-time.pipes';
import { NgTimeAgoPipe } from './measurements/time-ago.pipes';
import { NgDigitalUnitPipe } from './measurements/units.pipes';
import { NgFilterPipe } from './others/filters.pipes';
import { NgKeysPipe } from './others/helpers.pipes';
import { NgSafeHtmlPipe } from './sanitizers/safe-html.pipes';
import { NgSafeUrlPipe } from './sanitizers/safe-url.pipes';
import { NgHighlightTextPipe } from './formatting/highlight-text.pipe';
import { NgPercentLimitPipe } from './formatting/percent-limit.pipe';


@NgModule({
	declarations: [
		//** Formatting */
		NgFormatNumberPipe,
		NgTruncatePipe,
		NgHighlightTextPipe,
		NgPercentLimitPipe,

		//** Measurements */
		NgExactRemainingTimePipe,
		NgTimeAgoPipe,
		NgDigitalUnitPipe,

		//** Others */
		NgFilterPipe,
		NgKeysPipe,

		//** Sanitizers */
		NgSafeHtmlPipe,
		NgSafeUrlPipe
	],
	imports: [
		CommonModule
	],
	exports: [
		//** Formatting */
		NgFormatNumberPipe,
		NgTruncatePipe,
		NgHighlightTextPipe,
		NgPercentLimitPipe,

		//** Measurements */
		NgExactRemainingTimePipe,
		NgTimeAgoPipe,
		NgDigitalUnitPipe,

		//** Others */
		NgFilterPipe,
		NgKeysPipe,

		//** Sanitizers */
		NgSafeHtmlPipe,
		NgSafeUrlPipe
	]
})
export class NgPipesModule {}
